<script lang="ts">
	import { getDayString } from '../src/date-parser';

	export let url: string;
	export let date: string;
	export let index: number;

	const day = getDayString(date);
	let dayClass: string;
	if (day === 'Saturday') {
		dayClass = 'sat';
	} else if (day === 'Sunday') {
		dayClass = 'sun';
	} else {
		dayClass = 'weekday';
	}
</script>

<a href={url} class="quiz-module" class:top={index === 0}>
	<div class="thumb {dayClass}">
		<div class="thumb-text {dayClass}">{day.substring(0, 3).toLowerCase()}</div>
	</div>
	<div class="details">
		<p>{day} SuperQuiz</p>
		<div class="date">{date}</div>
	</div>
</a>

<style>
	a {
		color: #333;
		text-decoration: none;
		font-weight: 500;
	}

	.quiz-module:hover p {
		color: #5c00d1;
		text-decoration: underline;
	}

	.quiz-module {
		font-weight: 500;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ede9f1;
		padding: 20px 0;
		gap: 16px;
	}

	.quiz-module.top {
		border-top: 1px solid #ede9f1;
	}

	.date {
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		color: #777;
		font-size: 14px;
		line-height: 20px;
	}

	.thumb {
		height: 48px;
		width: 48px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.thumb.sun {
		background-color: #f8e3ff;
	}

	.thumb.sat {
		background-color: #b5179e;
	}

	.thumb.weekday {
		background-color: #f8f0ff;
	}

	.details {
		flex-grow: 1;
	}

	.details p {
		margin: 0 0 4px;
	}

	.thumb-text {
		font-family: 'Rowdies', cursive;
		font-weight: 300;
		font-size: 16px;
		line-height: 24px;
	}

	.thumb-text.sun {
		color: #b5179e;
	}

	.thumb-text.sat {
		color: #fff;
	}

	.thumb-text.weekday {
		color: #911eba;
	}
</style>
